// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { CircularProgress, Dialog } from '@material-ui/core';

const Loading = (props) => (
  <Dialog
    open
    fullScreen
    BackdropProps={{ invisible: true }}
    transitionDuration={0}
    PaperProps={{
      style: {
        backgroundColor: props.backgroundColor,
        backdropFilter:  'blur(5px)',
        display:         'flex',
        justifyContent:  'center',
        alignItems:      'center',
        width:           '100%',
        height:          '100vh',
        boxShadow:       'none',
      },
    }}
  >
    <CircularProgress className="mt-3" color="secondary" />
  </Dialog>
);

Loading.propTypes = {
  backgroundColor: PropTypes.string,
};

Loading.defaultProps = {
  backgroundColor: 'rgba(255,255,255,0.4)',
};

export default Loading;
